import React, { Component } from "react";
import { jsPDF } from "jspdf";
import * as moment from 'moment'
import domtoimage from 'dom-to-image'

import './pdf.css'

import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import MapExport from "./MapExport"

import iconoRef from '../../images/ficha_specie/icono-referencias.png'
import iconoWebLink from '../../images/ficha_specie/web_link.png'
import cabecera from '../../images/cabecera-pdf.png'

const utils = require("../auxiliar/aux_functions")
const { capitalize } = utils;

const getImageInfo = (file) => {
  return new Promise (function (resolved, rejected) {
    var i = new Image()
    i.setAttribute('crossOrigin', 'anonymous');
    i.onload = function(){
        var canvas = document.createElement('CANVAS');
                   var ctx = canvas.getContext('2d');
                   var dataURL;
                   canvas.height = this.height;
                   canvas.width = this.width;
                   ctx.drawImage(this, 0, 0);
                   dataURL = canvas.toDataURL("image/png");
                   let aspectRatio = i.height / i.width
                   resolved({dataURL, aspectRatio})
    };
    i.src = file
  })
}

// const getImageDimensions = (file) => {
//   return new Promise (function (resolved, rejected) {
//     var i = new Image()
//     i.onload = function(){
//         let aspectRatio = i.height / i.width
//       resolved({aspectRatio})
//     };
//     i.src = file
//   })
// }

class PDFGenerator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            id_specie: "",
            lang: this.props.lang,
            tFn: this.props.translateFn
        };
    }

    async extractMapImage() {
        await domtoimage.toBlob(document.getElementsByClassName('leaflet-container')[0])
            .then( (blob) => {
                var reader = new FileReader()
                reader.onloadend = () => {
                    this.buildSpeciePDF(reader.result)
                }
                reader.readAsDataURL(blob)
            })
    }


    async buildSpeciePDF(mapBase64) {

        let jsonData = null

        await fetch("https://eei.sibic.org/API/species.php?id=" + this.props.id_specie + "&lang=" + this.state.lang)
        .then(response => response.json())
        .then(data => { jsonData = data })

        let imagesMap = []
        let urls = []

        jsonData.images.forEach(img => {

            let imgUrl = `https://admin.eei.sibic.org/assets/img/species/${img.file_name}`

            urls.push(imgUrl)

            imagesMap.push({
                imgUrl,
                author: img.author,
                name: img.file_name,
                base64: null,
                aspectRatio: null,
                featured: img.featured
            })
        })


        for (let img of imagesMap) {
            let r = await getImageInfo(img.imgUrl)
            img.base64 = r.dataURL
            img.aspectRatio = r.aspectRatio
        }


        let doc =  new jsPDF('p', 'mm', 'a4', true)

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight()
        const marginLeft = 25
        const marginRight = 25
        const marginTop = 25
        const marginBottom = 25

        const cabeceraRatio = 0.0831307729703452

        const calculateImgSizeWithRatio = (widthPer, ratio) => {
            let width = (pageWidth - marginLeft - marginRight) * ( widthPer / 100 )
            let height = ratio * width
            return { width, height }
        }

        let posX = marginLeft
        let posY = 0

        doc.addImage(cabecera, "PNG", 0, 0, pageWidth, (pageWidth * cabeceraRatio), undefined,'FAST');

        posY += (pageWidth * cabeceraRatio)
        posY += 15

        //SPECIE

        doc.setFontSize(18)
        doc.setFont("helvetica", "bolditalic")
        doc.text(jsonData.species.taxa, posX, posY);
        let titleWidth = doc.getTextWidth(jsonData.species.taxa);

        doc.setFontSize(12)
        doc.setTextColor(100)
        doc.setFont("helvetica", "normal")
        doc.text(jsonData.species.authority, (posX + titleWidth + 2), posY);

        posY += 7

        let featuredImg = imagesMap.filter(img => img.featured === '1')[0] || imagesMap[0]
        let featuredImgSize = calculateImgSizeWithRatio(60, featuredImg.aspectRatio)
        doc.addImage(featuredImg.base64, "PNG", posX, posY, featuredImgSize.width, featuredImgSize.height, undefined,'FAST');

        let generalDataXPos = posX + featuredImgSize.width + 5
        let generalDataYPos = posY + 5

        doc.setFontSize(10)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        let w = doc.getTextWidth(this.state.tFn("ficha-primReg"))
        doc.text(this.state.tFn("ficha-primReg"), generalDataXPos , generalDataYPos);
        doc.setFont("helvetica", "normal")
        doc.text(`${jsonData.species.first_introduced_basin ? jsonData.species.first_introduced_basin : '' }${jsonData.species.first_introduced_basin ? ',': ''} ${jsonData.species.first_record ? jsonData.species.first_record: ''}`, generalDataXPos + w + 2 , generalDataYPos);

        generalDataYPos += 6.5
        doc.setFont("helvetica", "bold")
        w = doc.getTextWidth(this.state.tFn("ficha-nomCom"))
        doc.text(this.state.tFn("ficha-nomCom"), generalDataXPos , generalDataYPos);
        doc.setFont("helvetica", "normal")
        let text = jsonData.common_names.map(cN => `${cN.common_name} (${capitalize(cN.language)})`).join(', ')
        let splitted = doc.splitTextToSize(text, (pageWidth - marginRight - generalDataXPos ))
        doc.text(splitted, generalDataXPos , generalDataYPos +6.5);


        generalDataYPos += doc.getTextDimensions(splitted).h + 2 + 6.5
        doc.setFont("helvetica", "bold")
        doc.text(this.state.tFn("ficha-reino"), generalDataXPos , generalDataYPos);
        w = doc.getTextWidth(this.state.tFn("ficha-reino"))
        doc.setFont("helvetica", "normal")
        doc.text(jsonData.species.realm, generalDataXPos + w + 2 , generalDataYPos);


        generalDataYPos += 6.5
        doc.setFont("helvetica", "bold")
        doc.text(this.state.tFn("ficha-filo"), generalDataXPos , generalDataYPos);
        w = doc.getTextWidth(this.state.tFn("ficha-filo"))
        doc.setFont("helvetica", "normal")
        doc.text(jsonData.species.phylum, generalDataXPos + w + 2 , generalDataYPos);


        generalDataYPos += 6.5
        doc.setFont("helvetica", "bold")
        doc.text(this.state.tFn("ficha-clase"), generalDataXPos , generalDataYPos);
        w = doc.getTextWidth(this.state.tFn("ficha-clase"))
        doc.setFont("helvetica", "normal")
        doc.text(jsonData.species.class, generalDataXPos + w + 2 , generalDataYPos);

        generalDataYPos += 6.5
        doc.setFont("helvetica", "bold")
        doc.text(this.state.tFn("ficha-orden"), generalDataXPos , generalDataYPos);
        w = doc.getTextWidth(this.state.tFn("ficha-orden"))
        doc.setFont("helvetica", "normal")
        doc.text(jsonData.species.order, generalDataXPos + w + 2 , generalDataYPos);

        generalDataYPos += 6.5
        doc.setFont("helvetica", "bold")
        doc.text(this.state.tFn("ficha-familia"), generalDataXPos , generalDataYPos);
        w = doc.getTextWidth(this.state.tFn("ficha-familia"))
        doc.setFont("helvetica", "normal")
        doc.text(jsonData.species.family, generalDataXPos + w + 2 , generalDataYPos);


        posY =  posY + featuredImgSize.height + 5
        doc.setFontSize(8)
        doc.setTextColor(255,255,255)
        doc.setFillColor(28, 28, 28)
        let authorWidth = doc.getTextWidth(featuredImg.author);
        doc.rect((posX + featuredImgSize.width - (authorWidth + 8)), posY, (authorWidth + 8) , 5, "F")
        doc.text(('© ' +featuredImg.author), (posX + featuredImgSize.width - (authorWidth + 8) + 2.5 ), (posY + 3.5));

        posY +=  10
        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        doc.line(posX, posY, (pageWidth - marginRight), posY)




        //DESCRIPTION

        posY +=  15

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-desc"), posX , posY);

        posY += 10
        doc.setFontSize(12)
        doc.setFont("helvetica", "normal")
        let desc = doc.splitTextToSize(jsonData.species.description, (pageWidth - marginLeft - marginRight))
        doc.text(desc, posX , posY);

        posY = posY + doc.getTextDimensions(desc).h + 5
        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        doc.line(posX, posY, (pageWidth - marginRight), posY)

        //EICAT

        posY +=  15

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-eicat"), posX , posY);

        posY += 10

        for (let category of jsonData.eicat_category) {
            try {


                let text = this.props.eicatCategories.filter(c => c.eicat_id === category.eicat_id)[0].eicat
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.text(text, posX , posY);

                posY+= 10

            } catch (error) {
                console.error(`Eicat Category failed`)
            }
        }

        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        doc.line(posX, posY, (pageWidth - marginRight), posY)


        //INVASAQUA LIST

        posY +=  15

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-invasaqualist"), posX , posY);

        posY += 10


        for (let list of jsonData.invasaqua_lists) {
            try {

                let image_src = require('../../images/ficha_specie/check.png').default
                let r = await getImageInfo(image_src.default || image_src)
                let text = this.props.invasaquaLists.filter(l => l.invasaqua_id === list.invasaqua_id)[0].invasaqua
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r.dataURL, "PNG", posX , posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX + 5) , (posY +3));

                posY+= 10

            } catch (error) {
                console.error(`Check Image could not be fetched`)
            }
        }

        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        doc.line(posX, posY, (pageWidth - marginRight), posY)

        //GENERAL REFS
        posY +=  15

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-ref"), posX , posY);

        posY +=  6

        if (jsonData.species_reference.length === 0) {
            doc.setFontSize(12)
            doc.setFont("helvetica", "normal")
            doc.text(this.state.tFn("sin-ref"), posX , (posY + 2));
            posY += 8
        }

        jsonData.species_reference.forEach(ref => {

            if (pageHeight - posY  < marginBottom) {
                doc.addPage()
                posY = marginTop
            }

            doc.addImage(iconoRef, "PNG", posX, posY, 8, 8, undefined,'FAST');
            doc.setFontSize(8)
            doc.textWithLink(ref.publication_cite, (posX + 8 ), (posY + 5), {
              url: ref.publication_hyperlink
            })
            const textWidth = doc.getTextWidth(ref.publication_cite);
            doc.setDrawColor(33, 37, 41)
            doc.setLineWidth(0.25)
            doc.line((posX + 8 ), (posY + 6), (posX + 8 + textWidth), (posY + 6))


            let refD = doc.splitTextToSize(ref.reference, (pageWidth - marginLeft - marginRight - 4))
            let rectH = doc.getTextDimensions(refD).h + 4
            doc.setFillColor(220, 220, 220)
            doc.rect(posX, (posY + 10), (pageWidth - marginLeft - marginRight) , rectH, "F")
            doc.text(refD, (posX + 2) , (posY + 14));

            posY  = posY + rectH + 15

        })

        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        posY += 5
        doc.line(posX, posY, (pageWidth - marginRight), posY)

        //MAP
        let r = await getImageInfo(mapBase64)
        let mapSize = calculateImgSizeWithRatio(100, r.aspectRatio)

        if (pageHeight - posY - marginBottom < mapSize.height) {
            doc.addPage()
            posY = marginTop
        } else {
            posY +=  15
        }

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("mapa"), posX , posY);
        posY +=  7

        doc.addImage(mapBase64, "PNG", posX , posY, mapSize.width, mapSize.height, undefined,'FAST');

        posY += ( mapSize.height + 10)

        try {

            let image_check_src = require('../../images/ficha_specie/check.png').default
            let image_cross_src = require('../../images/ficha_specie/cross.png').default
            let r_check = await getImageInfo(image_check_src.default || image_check_src)
            let r_cross = await getImageInfo(image_cross_src.default || image_cross_src)

            let textWidthLists = doc.getTextWidth(this.state.tFn("ficha-listEu")) + 5;


            if (jsonData.species.european_list === 0) {

                let text = this.state.tFn("ficha-listEu")
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r_cross.dataURL, "PNG", posX , posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX + 5) , (posY +3));

            } else {
                let text = this.state.tFn("ficha-listEu")
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r_check.dataURL, "PNG", posX , posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX + 5) , (posY +3));
            }

            if (jsonData.species.spanish_list === 0) {

                let text = this.state.tFn("ficha-listEsp")
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r_cross.dataURL, "PNG", (posX + textWidthLists) , posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX + textWidthLists + 5) , (posY +3));

            } else {
                let text = this.state.tFn("ficha-listEsp")
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r_check.dataURL, "PNG", ( posX + textWidthLists), posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX + textWidthLists + 5) , (posY +3));
            }

            textWidthLists =  textWidthLists + doc.getTextWidth(this.state.tFn("ficha-listEsp")) + 20;


            if (jsonData.species.portuguese_list === 0) {

                let text = this.state.tFn("ficha-listPt")
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r_cross.dataURL, "PNG", ( posX + textWidthLists) , posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX + textWidthLists + 5) , (posY +3));

            } else {
                let text = this.state.tFn("ficha-listPt")
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r_check.dataURL, "PNG", ( posX + textWidthLists) , posY, 3, 3, undefined,'FAST');
                doc.text(text, (posX+ textWidthLists + 5) , (posY +3));
            }



            posY+= 10

        } catch (error) {
            console.error(`Error while trying to print lists`)
        }






        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        doc.line(posX, posY, (pageWidth - marginRight), posY)

        //HABITATS

        if (pageHeight - posY - marginBottom < 30) {
            doc.addPage()
            posY = marginTop
        } else {
            posY +=  15
        }

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("habitats"), posX , posY);

        posY +=  7

        for (let habitat of jsonData.habitats) {
            try {

                let image_src = require('../../images/ficha_specie/habitats/' + habitat.img).default
                let r = await getImageInfo(image_src.default || image_src)
                let text = capitalize(habitat.habitat)
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r.dataURL, "PNG", posX , posY, 20, 20, undefined,'FAST');
                doc.text(text, (posX + 24) , (posY + 11));

                posY+= 25

            } catch (error) {
                console.error(`Image ${habitat.img} could not be fetched`)
            }
        }
        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        posY += 5
        doc.line(posX, posY, (pageWidth - marginRight), posY)

        //VIAS

        if (pageHeight - posY - marginBottom < 30) {
            doc.addPage()
            posY = marginTop
        } else {
            posY +=  15
        }

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-vias"), posX , posY);

        posY +=  7

        for (let via of jsonData.pathways) {
            try {

                let image_src = require('../../images/ficha_specie/pathways/' + via.specific_img)
                let r = await getImageInfo(image_src.default || image_src)
                doc.setFontSize(12)
                doc.setFont("helvetica", "normal")
                doc.addImage(r.dataURL, "PNG", posX , posY, 20, 20, undefined,'FAST');
                doc.text(via.specific_pathway, (posX + 24) , (posY + 9));
                doc.setFontSize(8)
                doc.text(via.general_pathway, (posX + 24) , (posY + 13));

                posY+= 25

            } catch (error) {
                console.error(`Image ${via.specific_img} could not be fetched`)
            }
        }
        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        posY += 5
        doc.line(posX, posY, (pageWidth - marginRight), posY)


        //WEB REFS

        if (pageHeight - posY - marginBottom < 30) {
            doc.addPage()
            posY = marginTop
        } else {
            posY +=  15
        }

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-web"), posX , posY);

        posY +=  7

        if (jsonData.webpages.length === 0) {
            doc.setFontSize(12)
            doc.setFont("helvetica", "normal")
            doc.text(this.state.tFn("sin-ref"), posX , (posY + 2));
            posY += 8
        }

        jsonData.webpages.forEach(web => {

            if (pageHeight - posY  < marginBottom) {
                doc.addPage()
                posY = marginTop
            }

            doc.addImage(iconoWebLink, "PNG", posX, posY, 4, 4, undefined,'FAST');
            doc.setFontSize(8)
            doc.textWithLink(web.webpage, (posX + 5 ), (posY + 3), {
              url: web.webpage
            })
            const textWidth = doc.getTextWidth(web.webpage);
            doc.setDrawColor(33, 37, 41)
            doc.setLineWidth(0.25)
            doc.line((posX + 5 ), (posY + 4), (posX + 5 + textWidth), (posY + 4))

            posY  = posY + 10

        })

        doc.setDrawColor(220, 220, 220)
        doc.setLineWidth(0.15)
        posY += 5
        doc.line(posX, posY, (pageWidth - marginRight), posY)


        //IMAGES

        if (pageHeight - posY - marginBottom < 30) {
            doc.addPage()
            posY = marginTop
        } else {
            posY +=  15
        }

        doc.setFontSize(18)
        doc.setFont("helvetica", "bold")
        doc.setTextColor(33, 37, 41)
        doc.text(this.state.tFn("ficha-img"), posX , posY);

        posY +=  7

        let nonFeatIimgs = imagesMap.filter(img => img.featured === '0')

        if (nonFeatIimgs.length > 0) {
            nonFeatIimgs.forEach(image => {

                let imgSize = calculateImgSizeWithRatio(100, image.aspectRatio)

                if (pageHeight - posY  < imgSize.height) {
                    doc.addPage()
                    posY = marginTop
                }

                doc.addImage(image.base64, "PNG", posX, posY, imgSize.width, imgSize.height, undefined,'FAST');

                posY =  posY + imgSize.height - 5
                doc.setFontSize(8)
                doc.setTextColor(255,255,255)
                doc.setFillColor(28, 28, 28)
                let authorWidth = doc.getTextWidth(image.author);
                //let cW = doc.getTextWidth('© ');
                doc.rect((posX + imgSize.width - (authorWidth + 8)), posY, (authorWidth + 8) , 5, "F")
                doc.text(('© ' +image.author), (posX + imgSize.width - (authorWidth + 8) + 2.5 ), (posY + 3.5));

                posY += 15

            })

        } else {
            doc.setFontSize(12)
            doc.setFont("helvetica", "normal")
            doc.text(this.state.tFn("sin-img"), posX , (posY + 1));
        }




        let dateS = moment().format('DD-MM-YYYY')
        doc.save(`${jsonData.species.taxa}_${dateS}.pdf`);


        this.props.onFinish()
    }

    startBuildPDF = () => {
        setTimeout(() => this.extractMapImage(), 3000)
    }


    render() {
        if (this.state.loading) {
            return (
                <>
                    <Modal show={true} centered onHide={() => {}}>
                        <Modal.Body>
                            <PDFSpinner/>
                            <div className="centered-text">{this.state.tFn("wait-pdf")}</div>
                        </Modal.Body>
                    </Modal>
                    <div style={{position:'absolute', zIndex: -100}}>
                        <MapExport sibicId={this.props.id_specie} easinId={this.props.easinId} callback={this.startBuildPDF} onlyMap={true} onClose={() => {}}/>
                    </div>
                </>
            );
        }
    }
}

const PDFSpinner = (props) => (
    <div>
        <div className="bullets centered-text">
            <Spinner className="spin m-3" animation="grow" variant="success" />
            <Spinner className="spin m-3" animation="grow" variant="info" />
            <Spinner className="spin m-3" animation="grow" variant="success" />
        </div>
    </div >
)

export default PDFGenerator
